import { render, staticRenderFns } from "./AudioWaveComponent.vue?vue&type=template&id=c606389a&scoped=true"
import script from "./AudioWaveComponent.vue?vue&type=script&lang=js"
export * from "./AudioWaveComponent.vue?vue&type=script&lang=js"
import style0 from "./AudioWaveComponent.vue?vue&type=style&index=0&id=c606389a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c606389a",
  null
  
)

export default component.exports